import { render, staticRenderFns } from "./ServicesWorkshop.vue?vue&type=template&id=7d10a632&scoped=true&"
import script from "./ServicesWorkshop.vue?vue&type=script&lang=js&"
export * from "./ServicesWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./ServicesWorkshop.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ServicesWorkshop.vue?vue&type=style&index=1&id=7d10a632&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10a632",
  null
  
)

export default component.exports